import React, {useRef, useEffect, createRef} from "react";

import {
  Button,
  Card,  CardHeader,  CardBody,  CardTitle, CardImg, CardSubtitle,CardText,CardLink,
  Table,  Row,  Col,
  FormGroup,  Label,  Input,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import Request from '../../common/Request';
import WithRole from '../FormParts/ButtonWithRole';
import InputFile from '../FormParts/InputFile';
import InputCheckBox from '../FormParts/InputCheckBox'
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import { fade, withStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import { useSpring, animated } from 'react-spring';
import Pagination from "components/Pagination/MyPagination.jsx";
import Datetime from "react-datetime";
import queryString from 'query-string';
import SystemInfo from '../ViewParts/SystemInfo';
import { template } from "underscore";
import List from "../Estimate/List";
import GsuiteAuth from '../../components/Auth/GsuiteAuth'
import InputText from "../FormParts/InputText";
import { GetMessage, getErrorCodes } from '../../variables/message';

var domain = "";  

class Detail extends React.Component {
  constructor(props){
    super(props);
    this.state ={
        title: "トークルーム",
        project_natural_id:this.props.match.params.project_id,
        project:{},
        send_flag:false,
        messages:{
          count:0,
          new_message:{},
          history:[]
        },
        temp_file:{
          file_name:"",
          file_base64:""
        },
        data:[],
        edit_message_id:null,
        message_modal:false,
        regist_message_modal:false,
        fileupload_modal:false,
        input_message:"",
        edit_message:"",
        data :{
          values:{},
          errors:{
            message:[GetMessage(2024)],
          },
          requiredData :{
            message:[GetMessage(2024)],
          }
        },
        editData : {
          values : {},
          errors:{
          },
          requiredData :{
            edit_message:[GetMessage(2024)],
          }
        }
    };
    this.parentRef = createRef();
    this.ref = createRef();

    this.validateCallback = this.validateCallback.bind(this);
    this.validateCallbackForEdit = this.validateCallbackForEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.toggleFileuploadModal = this.toggleFileuploadModal.bind(this);
    this.updateMessageState = this.updateMessageState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEditChange = this.handleEditChange.bind(this);
    this.removeHistoryMessage = this.removeHistoryMessage.bind(this);
    this.changeAlreadyRead = this.changeAlreadyRead.bind(this);
    this.toggleRegistMessage = this.toggleRegistMessage.bind(this);
    this.registNewMessage = this.registNewMessage.bind(this);
    this.message_buttons = this.message_buttons.bind(this);
    this.render_messages = this.render_messages.bind(this);
    this.removeHistoryAttacheFile = this.removeHistoryAttacheFile.bind(this);
  } 

  search(){
    Request.get('/api/customer_message/' + this.props.match.params.project_id, {ulid: this.props.ulid},
      res => {
        console.log(res.Data);
        this.setState({messages:{
          count:res.Data.count,
          new_message:"",
          history:res.Data.history
        }
      })
    }, ()=>{}, ()=>{}, true, false, false );
    Request.get('/api/customer_message/project/' + this.props.match.params.project_id, {ulid: this.props.ulid},
    res => {
      console.log(res.Data)
      const now = new Date();
      const {customer_system_use_flag,customer_system_end_date,cb_customer_system_use_flag,cb_customer_system_end_date} = res.Data
      const end_date = customer_system_end_date != null && customer_system_end_date != "" ? new Date(customer_system_end_date) : null;
      const cb_end_date = cb_customer_system_end_date != null && customer_system_end_date != "" ? new Date(cb_customer_system_end_date): null;
  
      console.log(customer_system_use_flag,end_date,cb_customer_system_use_flag,cb_end_date,now)
      
      const send_flag = (end_date === null && customer_system_use_flag === 1 && cb_end_date === null && cb_customer_system_use_flag === 1) 
                        ||(end_date > now && customer_system_use_flag === 1 && cb_end_date === null && cb_customer_system_use_flag === 1) 
                        ||(end_date === null && customer_system_use_flag === 1 && cb_end_date > now && cb_customer_system_use_flag === 1) 
                        ||(end_date > now && customer_system_use_flag === 1 && cb_end_date > now && cb_customer_system_use_flag === 1) 
  
      console.log(send_flag)
      this.setState({project:res.Data,send_flag: send_flag})
    }, ()=>{}, ()=>{}, true, false, false );
  }

  componentDidMount() {
    this.search()
    this.interverID =setInterval(() => {
      this.search();
    }, 1000 * 60 * 2)
  }
  componentWillUnmount(){
    clearInterval(this.interverID)
  }
  componentDidUpdate(prevProps) {
    if(this.props.match.params.project_id !== prevProps.match.params.project_id) {
      this.search();
    }
    if (this.parentRef) {
      this.parentRef.current.scrollTop = this.ref.current.offsetTop
    }
  }
  updateMessageState (status, prop = null) {
    /*
    prop {
      customer_user_name:"",
      create_date:"",
      body:"",
      create_system_type:1,
      file_id:"",
      file_name:""
    }
    */

    console.log(this.state.messages);

    var history_messages = this.state.messages.history;

    switch (status){
      case "regist":
          //history_messages.unshift(prop);
          history_messages.push(prop);

          if (!prop.body) {
            return;
          }

          this.setState({
            messages:{
              count: this.state.messages.count + 1,
              new_message:"",
              history:history_messages
            }
          });
        break;
      case "update":
        if (this.state.edit_message_id == null) {
          return;
        }
        for ( var n in history_messages ) {
          if (history_messages[n].message_id == this.state.edit_message_id) {
            history_messages[n].body = prop.body;
            break;
          }
        }
        this.setState({
          messages:{
            count:this.state.messages.count,
            new_message:"",
            history:history_messages
          }
        });

        break;
      case "delete":
        if (this.state.edit_message_id == null) {
          return;
        }
        var remove_num = null;
        for ( var n in history_messages ) {
          if (history_messages[n].message_id == this.state.edit_message_id) {
            remove_num = n;
            break;
          }
        }
        console.log("remove_num >>> "+remove_num);
        if (remove_num == null) {
          return;
        }
        // リストの削除
        history_messages.splice(remove_num, 1);

        this.setState({
          messages: {
            count: this.state.messages.count - 1,
            history:history_messages,
            new_message: ""
          }
          
        });
        break;
      }
  }

  editHistoryMessage ( ) {
  var req = {
    update_param:"body",
    body:this.state.editData.values.edit_message,
    project_id:this.state.project.project_id,
  }
  if(this.state.editData.values.edit_attache_file 
    && this.state.editData.values.edit_attache_file !== ""
    && this.state.editData.values.edit_attache_file_base64
  ){
    req = {
      ...req,
      edit_attache_file : this.state.editData.values.edit_attache_file,
      edit_attache_file_base64 : this.state.editData.values.edit_attache_file_base64
    }
  }

  Request.put("/api/customer_message/"+this.state.edit_message_id,req,res=>{
    console.log(res);
    // this.updateMessageState("update",req);
    // this.setState({
    //   edit_message:""
    //   });
      this.search()
    });
  }
  removeHistoryMessage ( props ) {
    this.setState({edit_message_id:props.message_id});
    this.props.alertModal.current.confirmCheck({
      title:'削除確認',
      message:"メッセージを削除します。よろしいですか？"
    },() => {
      var param = {
        status : false,
        update_param : "delete"
      }
      Request.put("/api/customer_message/"+this.state.edit_message_id, param, res=>{
        this.updateMessageState("delete")
      });
    },false)
  }
  changeAlreadyRead ( prop ) {
    var title = "";
    var message = "";
    if ( prop.already_read ) {
      title = "ステータス変更確認";
      message = "メッセージを未読にします。よろしいですか？";
    }
    else {
      title = "ステータス変更確認";
      message = "メッセージを既読にします。よろしいですか？";
    }

    this.props.alertModal.current.confirmCheck({
      title: title,
      message: message
    },()=>{
      var req = {
        update_param:"already_read",
        already_read:!prop.already_read
      }
  
      Request.put("/api/customer_message/"+prop.message_id,req,res=>{
        var history = this.state.messages.history
        console.log(res);
        for (var n in history) {
          if ( history[n].message_id == prop.message_id ) {
            history[n].already_read = req.already_read;
            break;
          }
        }
        this.setState({
          messages:{
            count:this.state.messages.count,
            history:history,
            new_message:null
          }
        });
      });
    },false)
  }
  toggleRegistMessage (replied=false) {
    this.setState({
      regist_message_modal:!this.state.regist_message_modal,
      regist_message:replied ? "すでに返信されていますが、メッセージを送信しますか？" : "メッセージを送信します。よろしいですか？"
    });
  }
  repliedCheck(callback = (replied) => {}) {
    Request.get('/api/customer_message/replied/'+this.state.project.project_id, {},
    res => {
      console.log(res.Data["replied"]);
      if(res.Data["replied"]) {
        callback(true);
      } else {
        callback(false);
      }
    }, ()=>{}, ()=>{}, true, false, false );
  }
  registNewMessage () {
    var req = {
      body: this.state.data.values.message,
      project_id:this.state.project.project_id,
      file_name:"",
      file_base64:""
    }
    if ( this.state.temp_file.file_name ) {
      req.file_name = this.state.temp_file.file_name;
      req.file_base64 = this.state.temp_file.file_base64;
    }
    Request.post("/api/customer_message",req,res=>{
      var user_name = GsuiteAuth.get("name");
      var new_message_data = res.data;
      new_message_data["user_name"] = user_name;
      // this.updateMessageState("regist",res.data);
      this.setState({
        input_message:"",
        temp_file:{
          file_name:"",
          file_base64:""
        },
        data :{
          ...this.state.data,
          values : {
            message : ""
          },
          errors : {
            message:[GetMessage(2024)],
          }
        }
      });
      const is_sms_error = res.data.sms_error == undefined || res.data.sms_error == null ? false : true;
      if (is_sms_error) {
        let message = GetMessage(2631) 
        if (res.data.sms_error.error_code != undefined && res.data.sms_error.error_code != null) {
          message += "<br />" + JSON.stringify(res.data.sms_error.error_message);
        }
        let title = "エラー"
        this.props.alertModal.current.confirmCheck({
          title: title,
          message: message ,
          closeBtn: false
        }, () => {
          this.props.reloadUnread()
          this.search()
        }, false)
      } else {
        this.props.reloadUnread()
        this.search()        
      }
    },(err)=>{
      // エラー処理
    });
  }
  uploadTempFileState () {
    this.setState({
      temp_file:{
        file_name: this.state.data.values.attache_file,
        file_base64: this.state.data.values.attache_file_base64,
      }
    });
  }

  toggleMessageModal(prop=null) {
    if ( prop != null ) {
      this.setState({
        message_modal:!this.state.message_modal,
        edit_message_id:prop.message_id
      });
    }
    else {
      this.setState({
        message_modal:!this.state.message_modal
      });
    }
    return;
  }

  toggleFileuploadModal() {
    this.setState({
      fileupload_modal:!this.state.fileupload_modal,
      
      // 選択ファイル初期化
      data : {
        ...this.state.data,
        values : {
          ...this.state.data.values,
          attache_file : null
        }
      }
    });
    return;
  }

  validateCallback(newData){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
    })
  }

  validateCallbackForEdit(newData){
    this.setState({
      editData:{
        ...this.state.editData,
        ...newData
      },
    })
  }

  removeHistoryAttacheFile (prop) {
    this.props.alertModal.current.confirmCheck({
      title: "添付ファイル削除",
      message: "添付ファイルを削除します。よろしいですか？",
    },()=>{
      Request.put(
        "/api/customer_message/"+prop.message_id,
        {update_param:"file_id",file_name:"",file_base64:""},
        res=>{
          var history = this.state.messages.history
          for (var n in history) {
            if ( history[n].message_id == prop.message_id ) {
              history[n].file_id = "";
              history[n].file_name = "";
              break;
            }
          }
          this.setState({
            messages:{
              count:this.state.messages.count,
              history:history,
              new_message:null
            }
          });
        });
    },false)
  }
  removeAttacheFile () {
    this.setState({
      temp_file:{
        file_name:"",
        file_base64:"",
      }
    });
  }
  handleChange ( prop ) {
    this.setState({
      input_message:prop.target.value
    });
  }
  handleEditChange( prop ) {
    this.setState({
      edit_message:prop.target.value
    });
  }
  render_messages () {

    var unread_check = false;

    return (<>
      {this.state.messages.count > 0 &&(<>
        {this.state.messages.history.map((prop) => {
          return (<>
            {(()=>{
                if ( unread_check == false && prop.already_read == 0 ) {
                  unread_check = true
                  return (<>
                    <div className="new-header">新着</div>
                  </>)
                }
            })()}
            <div className="message-body">
              <table className="message-table">
                <tr>
                  <td className="table-body-left">
                    <div className="font-mid user">
                      <img src={require("assets/img/default-avatar.png")}/>
                      {prop.user_name}
                      {prop.create_system_type == 1 && prop.cums_already_read == 1 && (<div style={{backgroundColor:"#4ea72e",color:"#ffffff",borderRadius:"4px",display:"inline-block",padding:"2px 10px",marginLeft:"10px"}}>既読</div>)}
                    </div>
                    <div className="font-sml indent">{prop.create_date}{prop.update_date != null && prop.edit === 1 && (" modify:"+prop.update_date)}</div>
                    <div className="font-sml list-body">{prop.body}</div>
                  </td>
                  <td className="table-body-right">
                    {this.message_buttons(prop)}
                  </td>
                </tr>
              </table>
            </div>
            {prop.file_id &&(<>
              {/* <div className="font-sml attache_file_title">添付ファイル</div> */}
              <div className="message-body attache_file">
                <div className="icon">
                  <img src={require("assets/img/icon-file.jpeg")}/>&nbsp;&nbsp;
                </div>
                <div className="link">
                  <a href={`/api/gcs_download/${prop.file_path}?d=${prop.file_name}`} target="_blank">{prop.file_name}</a>
                </div>
                <div className="button">
                {prop.create_system_type === 1 && 
                  <input type="image" src={require("assets/img/icon-dust.jpeg")} onClick={()=>{this.removeHistoryAttacheFile(prop)}}/>
                }
                </div>
              </div>
            </>)}
            <br /><br />
          </>);
          })}
      </>)}
    </>);
  }

  message_buttons (prop) {
    const ButtonWithRole = WithRole(Button, this.props.buttons, null)

    return (<>
      {prop.create_system_type == 1 ? (<>
        { this.state.send_flag === true ?(<>
        <div>
          <ButtonWithRole button_id="" size="sm" color="info" onClick={() => {
            this.setState({
              editData : {
                ...this.state.editData,
                values : {
                  edit_message : prop.body,
                  edit_attache_file : prop.file_name
                }
              }
            })
            this.toggleMessageModal(prop);
          }}>メッセージ編集</ButtonWithRole>
        </div>
        <div>
          <ButtonWithRole button_id="" size="sm" color="info" onClick={()=>{this.removeHistoryMessage(prop);}}>メッセージ削除</ButtonWithRole>
        </div>
        </>):""}
      </>):(<>
        <input type="checkbox" name="already_read" className="already_check" checked={prop.already_read} disabled value="既読"/>
        {prop.already_read ? (<>
          <label className="already_check">
          <ButtonWithRole button_id="" size="sm" color="info" onClick={()=>{this.changeAlreadyRead(prop)}}>未読にする</ButtonWithRole>
          </label>
        </>):(<>
          <label className="already_check">
          <ButtonWithRole button_id="" size="sm" color="info" onClick={()=>{this.changeAlreadyRead(prop)}}>既読にする</ButtonWithRole>
          </label>
        </>)}
      </>)}
    </>);
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateForEdit(){
    let message = getErrorCodes(this.state.editData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }


  render() {
   console.log(this.state.project);
//    console.log(this.state.messages);
    const ButtonWithRole = WithRole(Button, this.props.buttons, null)

    return (
        <>
          <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader className="clearfix">
                  <CardTitle tag="h3" className="float-left">{this.state.title}</CardTitle>
                  <ButtonWithRole 
                    button_id="" 
                    size="sm" 
                    style={{marginTop: "26px"}}
                    onClick={() => {this.search()}}
                  >リフレッシュ</ButtonWithRole>
                </CardHeader>
                <CardBody className="detail cumessageField">
                  {/* チケット#2144 */}
                  <div className="cumessageHeader">工事ID：{this.props.match.params.project_id}</div>
                  <div className="cumessageList" id="list" ref={this.parentRef}>
                      {this.render_messages()}
                      <div id="list-tail" ref={this.ref}></div>
                  </div>

                  {this.state.send_flag === true ? (<>
                    <Row>
                      <Col md="1">
                        <input style={{width:"30px"}} type="image" src={require("assets/img/clip.jpeg")} onClick={()=>{this.toggleFileuploadModal()}}/>
                      </Col>
                      <Col md="10">
                        <InputText
                          label='本文'
                          multiline={true}
                          name='CUMESSAGE__message'
                          labelOn={false}
                          validateCallback={this.validateCallback}
                          rootData={this.state.data}
                          validateType={'regist'}
                        />
                      </Col>
                    </Row>
                    {this.state.temp_file.file_name && (
                    <>
                      <div className="attache_file font-sml">
                        <div className="icon"><img src={require("assets/img/icon-file.jpeg")}/></div>
                        <div className="link">{this.state.temp_file.file_name}</div>
                        <input type="image" src={require("assets/img/icon-dust.jpeg")}
                              disabled={!this.state.send_flag}
                              onClick={()=>{this.removeAttacheFile()}}/>
                      </div>
                      </> 
                    )}
                    
                    <div>
                      <ButtonWithRole button_id="" size="sm" color="info" 
                        disabled={!this.state.send_flag}
                        onClick={
                          ()=>{
                            if(this.validate()){
                              this.repliedCheck((replied) => {
                                this.toggleRegistMessage(replied)
                              });
                            }
                          }
                        }>メッセージを送信する</ButtonWithRole>
                    </div>
                  </>) : (<p style={{color:"red"}}>顧客システム利用されてない為、送信はできません。</p>)}


                </CardBody>
                
              </Card>
            </Col>
          </Row>
          </div>
          <Modal isOpen={this.state.message_modal} toggle={this.toggleMessageModal}>
            <div className="modal-header modal-header-center">メッセージの編集</div>
            <ModalBody>
              <div className="modal-body-input">
                {/* 本文&nbsp;<textarea value={this.state.editData.values.edit_message} onChange={this.handleEditChange} className="modalTextarea"/> */}
              </div>
              <Row>
                <Col>
                  <InputText
                    label='本文'
                    multiline={true}
                    name='CUMESSAGE__edit_message'
                    labelOn={true}
                    validateCallback={this.validateCallbackForEdit}
                    rootData={this.state.editData}
                    validateType={'regist'}
                  />
                </Col>
              </Row>
              <Row style={{marginTop: "10px"}}>
                <Col>添付ファイル：</Col>
              </Row>
              <Row>
                <Col>
                  <InputFile 
                    label="添付ファイル"
                    name="CUMESSAGE__edit_attache_file"
                    copy={false}
                    showLink={false}
                    validateCallback={this.validateCallbackForEdit} 
                    rootData={this.state.editData} 
                  />
                </Col>
              </Row>
              
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={()=>this.toggleMessageModal()}>キャンセル</Button>
              <Button color="info" onClick={()=>{
                if(this.validateForEdit()){
                  this.toggleMessageModal();
                  this.editHistoryMessage();
                }
              }}>OK</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.fileupload_modal} toggle={this.toggleFileuploadModal}>
            <div className="modal-header modal-header-center">添付ファイルのアップロード</div>
            <ModalBody>
              <div className="modal-body-input">
              <InputFile 
                  label="添付ファイル"
                  name="CUMESSAGE__attache_file"
                  copy={false}
                  showLink={false}
                  validateCallback={this.validateCallback} 
                  rootData={this.state.data} />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={()=>this.toggleFileuploadModal()}>キャンセル</Button>
              <Button color="info" onClick={()=>{this.toggleFileuploadModal(); this.uploadTempFileState()}}>ファイルを送信</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.regist_message_modal} toggle={this.toggleRegistMessage}>
            <div className="modal-header modal-header-center">送信確認</div>
            <ModalBody>
              <div className="modal-body-input">
                {this.state.regist_message}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={()=>this.toggleRegistMessage()}>キャンセル</Button>
              <Button color="info" onClick={()=>{this.toggleRegistMessage(); this.registNewMessage()}}>OK</Button>
            </ModalFooter>
          </Modal>
        </>
    );
  }
}

export default Detail;

